class PaymentListResponse {
    constructor({
        total_Members, paid,unPaid, free, maleCount, malePaidCount,maleUnPaidCount, maleFreeCount,
        feMaleCount, feMalePaidCount,feMaleUnPaidCount, feMaleFreeCount}
    ) {
        this.total_Members = total_Members;
        this.paid = paid;
        this.unPaid = unPaid;
        this.free = free;
        this.maleCount = maleCount;
        this.malePaidCount = malePaidCount;
        this.maleUnPaidCount =maleUnPaidCount;
        this.maleFreeCount = maleFreeCount;
        this.feMaleCount = feMaleCount;
        this.feMalePaidCount = feMalePaidCount;
         this.feMaleUnPaidCount = feMaleUnPaidCount;
        this.feMaleFreeCount = feMaleFreeCount;
        
      
    }
    static fromJson(json = {}) {
    return new PaymentListResponse({
        total_Members: json.total_Members ?? "",
        paid: json.paid ?? "",
        unPaid:json.unPaid ?? "",
        free: json.free ?? "",
        maleCount: json.maleCount ?? "",
        malePaidCount: json.malePaidCount ?? "",
        maleUnPaidCount:json.maleUnPaidCount ?? "",
        maleFreeCount: json.maleFreeCount ?? "",
        feMaleCount: json.feMaleCount ?? "",
        feMalePaidCount: json.feMalePaidCount ?? "",
        feMaleUnPaidCount:json.feMaleUnPaidCount ?? "",
        feMaleFreeCount: json.feMaleFreeCount ?? "",
       
       
    });
}


}
export default PaymentListResponse;